import { Fragment } from "react";
import { ParagraphProps } from "../../Types/CommonElementType";

const P: React.FC<ParagraphProps> = (props) => {
  return (
    <Fragment>
      <p {...props} style={props.style}>
        {props.children}
      </p>
    </Fragment>
  );
};

export default P;
